var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;}.a,.g{stroke:#707070;}.b{clip-path:url(#a);}.c,.g{fill:none;}.c{stroke:#fff;}.d{opacity:0.72;}.f{fill:#bebebe;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(0 -0.334)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0.334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.752 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-20836.348-24114.291h39.707",
    transform: "translate(20837.363 24147.631)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H33.167",
    transform: "translate(1.013 33.341) rotate(-90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(1.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.793,
    height: 33.177
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.266,
    height: 33.177,
    transform: "translate(16.852)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.266,
    height: 33.177,
    transform: "translate(5.793)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.793,
    height: 33.177,
    transform: "translate(22.119)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.793,
    height: 33.177,
    transform: "translate(11.059)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.266,
    height: 33.177,
    transform: "translate(33.705)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.793,
    height: 33.177,
    transform: "translate(28.355)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M201.791,524.592l5.311-9.235H212.8l5.4-1.94,5.657-2.458,5.4,2.458h6.556l5.528-2.458",
    transform: "translate(-200.7 -496.725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,13.633,5.311,4.4H11l5.4-1.94L22.061,0l5.4,2.458h6.557L39.544,0",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 38.197, 30.645)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.e5f238ba637ffcbd689b684f59d72323.svg";
export { ForwardRef as ReactComponent };